import { useMemo } from 'react';
import { useInterval } from 'usehooks-ts';
import { ExaminationStatusResponse } from '../api/maintestApi';
import {
  selectExaminationID,
  selectExaminationStatus,
} from '../redux/examination/selectors';
import { getExaminationStatus } from '../redux/examination/thunks';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { REQUEST_DELAY_TIME_MS } from './validation';

export const useIsExaminationFinished = () => {
  const dispatch = useAppDispatch();

  const examinationId = useAppSelector(selectExaminationID);
  const examinationStatus = useAppSelector(selectExaminationStatus);

  const examinationFinished = useMemo(
    () => examinationStatus,
    [examinationStatus]
  );

  useInterval(
    () => {
      void dispatch(getExaminationStatus(examinationId));
    },
    examinationFinished === ExaminationStatusResponse.finished ||
      examinationFinished === ExaminationStatusResponse.failed
      ? null
      : REQUEST_DELAY_TIME_MS
  );

  return examinationFinished;
};
